import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-ereceipt-dialogs',
  templateUrl: './ereceipt-dialogs.component.html',
  styleUrls: ['./ereceipt-dialogs.component.scss']
})
export class EreceiptDialogsComponent {
  email: any="";

  emailForm: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<EreceiptDialogsComponent>
  ){}
  ngOnInit(){
    this.initForm();
  }

  initForm(){
    this.emailForm = new FormGroup({
      'email' : new FormControl('', [Validators.required, Validators.email])
    });
  }
  
  close(){
    this.dialogRef.close(false);
  }

  submitEmail(){
    this.emailForm.markAllAsTouched();

    if(this.emailForm.invalid){
      return;
    }

    this.dialogRef.close({proceed: true, ...this.emailForm.value});
    
  }
}
